<template>
  <div>
    <div class="side-frame-success">
      <span style="font-size: 14px; color: #606266">{{
        $l('table_label_heard') || '纸箱库位信息'
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
